<template>
  <img
    v-if="src"
    class="inline-block rounded-full border-2 border-current group-hover:border-current/80"
    :src="src"
    alt=""
  >
  <div v-else class="inline-flex items-center justify-center overflow-hidden rounded-full border-2 border-current group-hover:border-current/80 leading-none">
    <Account class="" aria-hidden="true" />
  </div>
</template>

<script setup>
import Account from 'vue-material-design-icons/Account.vue';

defineProps({
  src: {
    type: String,
    default: null
  }
});
</script>
